// candidate.service.ts

import { IUserFormInput } from "../../Pages/User/User.model";
import { buildApiUrl } from "../../config/api";
import axiosInstance from "../axios/axiosInstance";

const API = buildApiUrl("/usersApp/users/");
const LOGGED_USER_API = buildApiUrl("/usersApp/current_user/");

export const userService = {
  async getAll() {
    return axiosInstance.get(API);
  },
  async create(payload: IUserFormInput) {
    return axiosInstance.post(API, payload);
  },
  async update(id: number, data: IUserFormInput) {
    try {
      const res = await axiosInstance.put(`${API}${id}/`, data);
      return { success: true, data: res.data };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
  async remove(id: number) {
    try {
      const res = await axiosInstance.delete(`${API}${id}/`);
      return { success: true, data: res };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
  async getCurrentUser() {
    return axiosInstance.get(LOGGED_USER_API);
  },
};
